module.exports = __webpack_public_path__ + "assets/img/11bp_519_2.fe3dfe76.jpg";